import { TEmployeeRole, TRESPONSE_SPAREPART_LIST, TSparePartDetails } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import _ from 'lodash';
import { TTableTreeModel } from '../../table.type';

export const SPAREPART_LIST_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_SPAREPART_LIST['spareParts'],
    selectedSp: TRESPONSE_SPAREPART_LIST['spareParts'],
    isSelectedFactoryDefaultFactory: boolean,
    employeeRole?: TEmployeeRole[number] | undefined,
    isPoEnabled?: boolean,
    isGrnEnabled?: boolean,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: isSelectedFactoryDefaultFactory ? { position: 'START', isMulti: true, size: 'DEFAULT' } : undefined,
        headerConfig: _.compact([
          employeeRole === 'FACTORY_GROUP_ADMIN'
            ? {
                type: 'TEXT_CELL',
                text: 'FACTORY ID',
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.SPAREPART',
          },
          isPoEnabled
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.PO',
                widthInPx: 100,
              }
            : undefined,
          isGrnEnabled
            ? {
                type: 'TEXT_CELL',
                text: 'table_model.GRN',
                widthInPx: 100,
              }
            : undefined,
          {
            type: 'TEXT_CELL',
            text: 'table_model.SPECIFICATION/SIZE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.BRAND',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.SPAREPARTNO.',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.QUANTITY/STOCK',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.THRESHOLD',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.CRITICAL',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.COST',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.REMARK',
          },
          isSelectedFactoryDefaultFactory && {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ]),
      },
      (item) => {
        const isThresholdBreached = item.thresholdOpt !== undefined && item.thresholdOpt > item.quantityInStock;
        return {
          type: 'ROW',
          rowItem: item,
          rowSelectionInfo: {
            isSelected: selectedSp.some((sp) => sp.id === item.id),
            isDisabled: false,
          },
          cells: _.compact([
            employeeRole === 'FACTORY_GROUP_ADMIN'
              ? {
                  type: 'TEXT_CELL',
                  text: item.factoryId,
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.sparePartName,
            },
            isPoEnabled
              ? {
                  type: 'TEXT_CELL',
                  text: item.poNumberOpt ?? '--',
                }
              : undefined,
            isGrnEnabled
              ? {
                  type: 'TEXT_CELL',
                  text: item.grnNumberOpt ?? '--',
                }
              : undefined,
            {
              type: 'TEXT_CELL',
              text: item.specification || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.brand,
            },
            {
              type: 'TEXT_CELL',
              text: item.sparePartNumber,
            },
            {
              type: 'TEXT_CELL',
              text: item.quantityInStock.toString(),
              verticalAlign: 'middle',
              textColor: isThresholdBreached ? 'RED' : undefined,
              icon: isThresholdBreached
                ? {
                    type: 'WARNING',
                    align: 'END',
                  }
                : undefined,
            },
            {
              type: 'TEXT_CELL',
              text: item.thresholdOpt?.toString() || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.isCritical ? 'Critical' : 'Not Critical',
            },
            {
              type: 'TEXT_CELL',
              text: String(item.costOpt ?? '--'),
            },
            {
              type: 'TEXT_CELL',
              text: item.remarkOpt ?? '--',
            },
            isSelectedFactoryDefaultFactory && {
              type: 'ACTION_CELL',
              actionType: 'EDIT',
              asIcon: true,
            },
          ]),
        };
      },
    );
  },

  deselectAllRows: (tableModel: TTableTreeModel<TSparePartDetails>): TTableTreeModel<TSparePartDetails> => {
    return ModifiersZTableModel.deselectAllRows(tableModel);
  },
};
